import {tns} from 'tiny-slider/src/tiny-slider';

function contentImageSlider() {
	const blocks = document.querySelectorAll('.block-content-images__image-slider');

	if (blocks) {
		blocks.forEach(block => {
			const speed = parseInt(block.getAttribute('data-speed'));
			const options = {
				'container': block,
				'controls': false,
				'nav': false,
				'items': 1,
				'autoplay': true,
				'autoplayTimeout': speed,
				'mode': 'gallery'
			};

			const slider = tns(options);
		});
	}
}

export default contentImageSlider;